import { useMsal, AuthenticatedTemplate } from '@azure/msal-react';
import { useMeContext } from '../api/me-provider.js';
import { signOutRequest } from '../auth/sign-out-request.js';

/**
 * Who is signed in, and Sign out, in the header.
 *
 * Nothing here while signed out (ruled 21 October, mockup *Header Sign In*):
 * every signed-out screen has its own Sign in or Sign up in the page
 * (SignInPrompt, WelcomeSignUp, both from ProfileGate), and a second one in
 * the corner beside the invitation's Sign up started the wrong path.
 *
 * Redirect rather than popup. The design is mobile-first and popup windows are
 * unreliable on phones - blocked by default in several browsers, and easy to
 * lose behind the page when they are not.
 *
 * Routes are gated by ProfileGate rather than here: this component is about who
 * is signed in, not about what they may do.
 */
export function SignInPanel() {
  const { instance } = useMsal();
  const { state } = useMeContext();
  const account = instance.getActiveAccount();

  /*
   * The name comes from the database, not from the token.
   *
   * External ID issues no given_name or family_name, and the `name` claim is the
   * literal string "unknown" - which is what this header displayed until profile
   * completion existed. account.name is still the fallback for the moment
   * between signing in and /api/me answering, and username (the email) after
   * that, so the header is never empty.
   */
  const profile = state.status === 'ready' ? state.me.profile : undefined;
  const who =
    profile?.first_name ??
    (account?.name && account.name !== 'unknown' ? account.name : undefined) ??
    account?.username ??
    'Signed in';

  return (
    <div className="sign-in-panel">
      <AuthenticatedTemplate>
        <span className="sign-in-who" title={account?.username ?? ''}>
          {who}
        </span>
        <button
          type="button"
          onClick={() => {
            void instance.logoutRedirect(signOutRequest(account));
          }}
        >
          Sign out
        </button>
      </AuthenticatedTemplate>
    </div>
  );
}
